<div class="modal-header bg-primary-100">
  <h5 class="modal-title">Bulk EIN Formatter</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label class="form-label" for="bulkInput">Paste your EIN list (one per line)</label>
    <textarea
      #pastedInputTextarea
      id="bulkInput"
      class="form-control"
      [(ngModel)]="pastedInput"
      (input)="formatEins()"
      name="bulkInput"
      rows="8"
      style="resize: vertical; max-height: 300px"
    ></textarea>
  </div>

  @if (formattedOutput()) {
    <div class="mb-3">
      <label class="form-label">Formatted Result (automatically copied)</label>
      <div
        class="form-control"
        style="
          background-color: #f5f5f5;
          max-height: 100px;
          overflow-y: auto;
          word-break: break-all;
          padding: 10px;
          font-family: monospace;
          font-size: 0.9rem;
        "
      >
        {{ formattedOutput() }}
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
